import { useAuth } from '@/contexts/AuthContext';

/**
 * Returns the propertyId and tenantId for the authenticated enterprise tenant admin.
 * The tenantId is the unitId from the enterprise_tenant_admin role entry.
 * Returns null if the user is not an enterprise_tenant_admin.
 */
export function useEnterpriseContext(): { propertyId: string; tenantId: string } | null {
  const { user } = useAuth();
  if (!user) return null;
  const role = user.propertyRoles.find((r) => r.role === 'enterprise_tenant_admin');
  if (!role?.propertyId || !role.unitId) return null;
  return { propertyId: role.propertyId, tenantId: role.unitId };
}
